// extracted by mini-css-extract-plugin
export var productImage = "_s2-1";
export var viewLink = "_s2-2";
export var wishlistItem = "_s2-0";